(function () {
  function initBlog(section) {
    var filter = section.querySelector('[data-tcb-blog-filter]');
    if (filter) {
      filter.addEventListener('change', function () {
        if (filter.value) {
          window.location.href = filter.value;
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-section-type="tcb-main-blog"]').forEach(initBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="tcb-main-blog"]');
    if (section) initBlog(section);
  });
})();
